import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import Image from '../../../components/ContentfulImage';
import Slider from '../../../components/Slider/Slider';
import Placeholder from '../../../components/Placeholder';

import {
  Wrapper,
  GridWrapper,
  SliderWrapper,
  TitleCell,
  TitleCellFiller,
  TitleCellContent,
  Title,
  StyleCell,
  CellInner,
} from './StylesGallery.style';

/**
 *「クリエーション」画面 > 各シーズンページ > 各スライダーの中身
 */
const StylesGallery = ({ copy, season, styles, locale, prevSlug, ancestor }) => {
  const titleCell = (
    <TitleCell>
      <TitleCellFiller />
      <TitleCellContent>
        <h5>{season} Trends</h5>
      </TitleCellContent>
    </TitleCell>
  );

  const styleCells =
    !!(styles && styles.length > 0) &&
    styles.map(style => (
      <StyleCell key={style.slug}>
        <Link
          to={{
            pathname: `/${locale}/style/${style.slug}`,
            state: {
              prevPath: `/${locale}/inspiration/${prevSlug}`,
              ancestor,
            },
          }}
          href={`/${locale}/style/${style.slug}`}
        >
          <CellInner>
            {style.images && (
              <Image src={style.images[0]} options={{ w: '100%', objectFit: 'cover', size: [250, 250, 600, 480] }} />
            )}
          </CellInner>
        </Link>
      </StyleCell>
    ));

  return (
    <React.Fragment>
      <Wrapper>
        <Title>{copy.collection || <Placeholder w="150px" h="20px" />}</Title>
        <GridWrapper>
          {titleCell}
          {styleCells}
        </GridWrapper>
        <SliderWrapper>
          <Slider options={{ loop: false }} dots={false}>
            {titleCell}
            {styleCells}
          </Slider>
        </SliderWrapper>
      </Wrapper>
    </React.Fragment>
  );
};

StylesGallery.defaultProps = {
  copy: {},
  season: undefined,
};

StylesGallery.propTypes = {
  ancestor: PropTypes.string.isRequired,
  copy: PropTypes.shape(),
  styles: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  prevSlug: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  season: PropTypes.string,
};

export default StylesGallery;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/StylesGallery/StylesGallery.js